
<template>
  <v-list-item link @click="modifier.uplimit === 1 ? portion.quantity == 0 ? $emit('inc', modifier) : $emit('dec', modifier) : () => {}">
    <v-list-item-content>
      <v-list-item-title>{{modifier.name}}</v-list-item-title>
      <v-list-item-subtitle><T>макс.</T>{{modifier.uplimit}}</v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action>
      <v-switch v-if="modifier.uplimit == 1" readonly :value="portion.quantity > 0" @click.stop="portion.quantity == 0 ? $emit('inc', modifier) : $emit('dec', modifier)"></v-switch>
      <div v-else>
        <v-btn :disabled="portion.quantity <= 0" fab color="primary" small @click.stop="$emit('dec', modifier)"><v-icon>mdi-minus</v-icon></v-btn>
        <span style="min-width: 30px; display: inline-block; text-align: center">{{portion.quantity}}</span>
        <v-btn :disabled="portion.quantity+1 > modifier.uplimit" fab color="primary" small @click.stop="$emit('inc', modifier)"><v-icon>mdi-plus</v-icon></v-btn>
      </div>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
export default {
  props: ['modifier', 'value'],
  computed: {
    portion() {
      return this.value.filter(el => el.modifier.id == this.modifier.id)[0] || {quantity: 0}
    }
  }
}
</script>